import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../../components/PageHeader/PageHeader';
import MetricRow from '../../components/MetricRow/MetricRow';
import MetricCard from '../../components/MetricCard/MetricCard';
import FilterTabs from '../../components/FilterTabs/FilterTabs';
import Button from '../../components/Button/Button';
import styles from './Researchers.module.css';

const Researchers = () => {
  const [activeFilter, setActiveFilter] = useState('All');
  const [searchTerm, setSearchTerm] = useState('');

  const filterTabs = ['All', 'Pro', 'Agency', 'Free', 'KYC Pending'];

  const researchersData = [
    {
      id: 1,
      name: 'Insight Loop Research',
      lead: 'Priya Nair · Delhi',
      plan: 'Pro',
      planColor: '#0060D4',
      planBg: '#ECF4FF',
      studies: 14,
      totalSpend: '₹8.2L',
      wallet: '₹42,500',
      kyc: 'Verified',
      kycColor: '#007A21',
      kycBg: '#DCFFE5'
    },
    {
      id: 2,
      name: 'Brandwise Consumer Labs',
      lead: 'Arjun Rao · Gurugram',
      plan: 'Agency',
      planColor: '#4E0089',
      planBg: '#F7EDFF',
      studies: 22,
      totalSpend: '₹14.6L',
      wallet: '₹1,20,000',
      kyc: 'Verified',
      kycColor: '#007A21',
      kycBg: '#DCFFE5'
    },
    {
      id: 3,
      name: 'Delhi Market Pulse',
      lead: 'Sana Khan · Delhi',
      plan: 'Free',
      planColor: '#60606B',
      planBg: '#F2F2F2',
      studies: 3,
      totalSpend: '₹74,160',
      wallet: '₹8,000',
      kyc: 'Verified',
      kycColor: '#007A21',
      kycBg: '#DCFFE5'
    },
    {
      id: 4,
      name: 'Northstar Qual',
      lead: 'Rahul Mehta · Mumbai',
      plan: 'Pro',
      planColor: '#0060D4',
      planBg: '#ECF4FF',
      studies: 6,
      totalSpend: '₹2.9L',
      wallet: '₹15,400',
      kyc: 'Pending',
      kycColor: '#6A4A00',
      kycBg: '#FFF9E6'
    },
    {
      id: 5,
      name: 'Freelance – Priya M.',
      lead: 'Bengaluru',
      plan: 'Free',
      planColor: '#60606B',
      planBg: '#F2F2F2',
      studies: 1,
      totalSpend: '—',
      wallet: '₹0',
      kyc: 'Not started',
      kycColor: '#60606B',
      kycBg: '#F2F2F2'
    }
  ];

  const filteredResearchers = researchersData.filter((r) => {
    const matchesSearch =
      r.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      r.lead.toLowerCase().includes(searchTerm.toLowerCase());
    if (activeFilter === 'Pro') return matchesSearch && r.plan === 'Pro';
    if (activeFilter === 'Agency') return matchesSearch && r.plan === 'Agency';
    if (activeFilter === 'Free') return matchesSearch && r.plan === 'Free';
    if (activeFilter === 'KYC Pending') return matchesSearch && r.kyc === 'Pending';
    return matchesSearch;
  });

  const headerActions = (
    <>
      <input
        type="text"
        placeholder="Search researchers..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className={styles.searchInput}
      />
      <Button
        variant="secondary"
        onClick={() => alert('Researchers list exported.')}
      >
        Export
      </Button>
    </>
  );

  return (
    <>
      <PageHeader
        title="Researchers"
        subtitle="Organisations and independent researchers running studies on Nopser."
        actions={headerActions}
      />

      <MetricRow columns={4}>
        <MetricCard label="Total accounts" value="148" subtext="+11 this month" />
        <MetricCard label="On Pro / Agency" value="32 / 6" subtext="26% paid" />
        <MetricCard label="KYC pending" value="9" subtext="business documents" />
        <MetricCard label="Wallet balances held" value="₹6.8L" subtext="across all accounts" />
      </MetricRow>

      <div style={{ marginTop: '20px' }}>
        <FilterTabs
          tabs={filterTabs}
          activeTab={activeFilter}
          onTabChange={setActiveFilter}
        />
      </div>

      <section className={styles.tableCard}>
        <div className={styles.tableHeader}>
          <div>Researcher</div>
          <div>Plan</div>
          <div>Studies</div>
          <div>Total spend</div>
          <div>Wallet</div>
          <div>KYC</div>
          <div></div>
        </div>

        {filteredResearchers.map((r) => (
          <div key={r.id} className={styles.tableRow}>
            <div>
              <div className={styles.researcherInfo}>
                <span className={styles.researcherName}>{r.name}</span>
                <span className={styles.researcherLead}>{r.lead}</span>
              </div>
            </div>

            <div>
              <span
                className={styles.badge}
                style={{ color: r.planColor, background: r.planBg }}
              >
                {r.plan}
              </span>
            </div>

            <div className={styles.cellText}>{r.studies}</div>
            <div className={styles.cellText}>{r.totalSpend}</div>
            <div className={styles.cellText}>{r.wallet}</div>

            <div>
              <span
                className={styles.badge}
                style={{ color: r.kycColor, background: r.kycBg }}
              >
                {r.kyc}
              </span>
            </div>

            <div>
              <Link to="/researcher-profile" className={styles.viewLink}>
                View →
              </Link>
            </div>
          </div>
        ))}
      </section>
    </>
  );
};

export default Researchers;
